export function interpolateProgressivePoint(totalPoints, pointIndex, bValue, outputStart, outputEnd) {
  if (typeof outputStart !== 'number' || typeof outputEnd !== 'number') {
    return NaN;
  }

  const ratio = getProgressionRatio(totalPoints, pointIndex, bValue);

  if (isNaN(ratio)) {
    return NaN;
  }

  return Math.round(outputStart + (outputEnd - outputStart) * ratio);
}

function getProgressionRatio(tp, pi, bv) {
  if (typeof tp !== 'number' || !Number.isInteger(tp) || tp < 1) return NaN;
  if (typeof pi !== 'number' || !Number.isInteger(pi) || pi < 0 || pi >= tp) return NaN;
  if (typeof bv !== 'number' || bv <= 0) return NaN;

  if (tp === 1) {
    return 1;
  }

  if (bv === 1) {
    return pi / (tp - 1);
  }

  const numerator = Math.pow(bv, pi) - 1;
  const denominator = Math.pow(bv, tp - 1) - 1;

  if (denominator === 0) {
    return pi / (tp - 1);
  }

  return numerator / denominator;
}
